import React, { useRef, useEffect } from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import aboutus from "../assets/aboutus.png";
import ZakatChart from "../components/zakatchart";
import MobileMasjidLogos from "../components/mobileMasjidLogos";
import MobileNavigationBar from "../components/mobileNavbar";
import MobileFooter from "../components/mobileFooter";
import { FaCalculator } from "react-icons/fa";
import { FaHandHoldingHeart } from "react-icons/fa6";

export const MobileAboutUs = () => {
    const exampleCaseRef = useRef(null);

    useEffect(() => {
        if (window.location.hash === '#example-case') {
            exampleCaseRef.current?.scrollIntoView({ behavior: 'smooth' });
        }
    }, []);
    return (
        <div className="home-page">
            <MobileNavigationBar />

            <Container className="my-3">
                {/* Intro + Image */}
                <Row className="mb-4">
                    <Col xs={12} className="mb-3">
                        <h3>How It Works:</h3>
                        <p style={{ fontSize: "16px" }}>
                            The Greater Austin Muslim Relief Committee (GAMRC) is a unified effort of all local Austin Masajid,
                            working together to fulfill the obligation of Zakah and provide aid to those in need. While GAMRC is NOT an independent
                            organization, it serves as a trusted channel for distributing Zakat to individuals and families facing hardship,
                            as well as Sadqah to non-Muslims in need. Your Zakat can be paid through any of the participating Masajid linked below.
                            GAMRC ensures that these funds are properly allocated to support essential needs such as food, shelter, medical care,
                            and education.
                        </p>
                    </Col>
                    <Col xs={12} className="d-flex justify-content-center">
                        <img src={aboutus} alt="Zakat Flow" className="img-fluid" style={{ maxWidth: "100%", height: "auto" }} />
                    </Col>
                </Row>

                {/* How Much It Takes Section */}
                <div className="mb-4" id="example-case" ref={exampleCaseRef}>
                    <h4>How Much It Takes to Support a Family in Austin</h4>
                    <p style={{ fontSize: "16px" }}>
                        Austin is an amazing city, but living expenses are high, and many families struggle to afford essentials like rent,
                        electricity, and food. This burden is especially heavy for single moms and refugee families.
                    </p>

                    <Row>
                        <Col xs={12} style={{ alignContent: 'center', margin: '0 auto' }}>
                            <h5
                                style={{
                                    color: "#3C256B",
                                    fontWeight: "700",
                                    marginBottom: "0.5rem",
                                    textAlign: "center",
                                }}
                            >
                                Example Of Minimum Living Cost <br /> single mother with children
                            </h5>
                            <p style={{ textAlign: 'center', fontSize: '1rem' }}>Sister S.J. from our community was kicked out by her husband along with her young children. Sadly, there are multiple cases like this within our community.</p>

                            <table
                                style={{
                                    width: "80%",
                                    maxWidth: "400px",
                                    borderCollapse: "collapse",
                                    fontFamily: "'Segoe UI', Tahoma, Geneva, Verdana, sans-serif",
                                    boxShadow: "0 2px 5px rgba(0,0,0,0.1)",
                                    margin: "0 auto",
                                }}
                            >
                                <thead>
                                    <tr
                                        style={{
                                            backgroundColor: "#3C256B",
                                            color: "white",
                                            textTransform: "uppercase",
                                            fontSize: "0.85rem",
                                        }}
                                    >
                                        <th
                                            style={{
                                                padding: "12px",
                                                borderBottom: "2px solid #C9DDAD",
                                                textAlign: "left",
                                            }}
                                        >
                                            Expense
                                        </th>
                                        <th
                                            style={{
                                                padding: "12px",
                                                borderBottom: "2px solid #C9DDAD",
                                                textAlign: "right",
                                            }}
                                        >
                                            Monthly Cost ($)
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {[
                                        { label: "Rent", amount: 1500 },
                                        { label: "Electricity", amount: 200 },
                                        { label: "Water", amount: 100 },
                                        { label: "Clothing", amount: 100 },
                                        { label: "Grocery / Food", amount: 1000 },
                                    ].map(({ label, amount }, idx) => (
                                        <tr
                                            key={label}
                                            style={{
                                                backgroundColor: idx % 2 === 0 ? "#fff" : "#F7F9F8",
                                                color: "#3C256B",
                                            }}
                                        >
                                            <td
                                                style={{
                                                    padding: "10px",
                                                    borderBottom: "1px solid #C9DDAD",
                                                    textAlign: "left",
                                                }}
                                            >
                                                {label}
                                            </td>
                                            <td
                                                style={{
                                                    padding: "10px",
                                                    borderBottom: "1px solid #C9DDAD",
                                                    textAlign: "right",
                                                }}
                                            >
                                                {amount.toLocaleString()}
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot
                                    style={{
                                        backgroundColor: "#C9DDAD",
                                        color: "#3F562F",
                                        fontWeight: "700",
                                        fontSize: "0.9rem",
                                    }}
                                >
                                    <tr>
                                        <td
                                            style={{
                                                padding: "12px",
                                                borderTop: "2px solid #3F562F",
                                                textAlign: "left",
                                            }}
                                        >
                                            Total Monthly
                                        </td>
                                        <td
                                            style={{
                                                padding: "12px",
                                                borderTop: "2px solid #3F562F",
                                                textAlign: "right",
                                            }}
                                        >
                                            {(1500 + 200 + 100 + 100 + 1000).toLocaleString()}
                                        </td>
                                    </tr>
                                    <tr>
                                        <td
                                            style={{
                                                padding: "12px",
                                                borderTop: "1px solid #3F562F",
                                                textAlign: "left",
                                            }}
                                        >
                                            Total Annual
                                        </td>
                                        <td
                                            style={{
                                                padding: "12px",
                                                borderTop: "1px solid #3F562F",
                                                textAlign: "right",
                                            }}
                                        >
                                            {((1500 + 200 + 100 + 100 + 1000) * 12).toLocaleString()}
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>

                        </Col>
                        <Col xs={12} className="mt-3">
                            <ul
                                style={{
                                    fontSize: "16px",
                                    lineHeight: "1.5",
                                    marginBottom: "0",
                                }}
                            >
                                <li style={{ marginBottom: "0.5rem" }}>
                                    We prepare single moms for about <strong>six months</strong> to gain skills for employment. Caring for young children makes
                                    working difficult, and <strong>child care is expensive</strong>, so we provide <strong>extended support</strong>.
                                </li>
                                <li style={{ marginBottom: "0.5rem" }}>
                                    Many refugees face <strong>skill barriers</strong>, <strong>low-paying jobs</strong>, large families, and <strong>limited government assistance</strong>
                                    (like food stamps) that don’t cover rent or utilities.
                                </li>
                                <li style={{ marginBottom: "0.5rem" }}>
                                    Support lasts from <strong>6 to 24 months</strong> depending on education, skills, and children’s ages until families can stand on their own.
                                </li>
                                <li style={{ marginBottom: "0.5rem" }}>
                                    We also help <strong>revert Muslims</strong> transition out of shelters, supporting their <strong>spiritual connection</strong> alongside basic needs.
                                </li>
                                <li style={{ marginBottom: "0.5rem" }}>
                                    Small donations between <strong>$200 and $300</strong> fall short of what families need to escape poverty and build lasting stability.
                                    <strong> Zakat</strong> is a right for everyone — refugees, reverts, elders — and should fully meet real needs.
                                </li>
                                <li>
                                    Life in Austin is different — costs are higher, <strong>halal food</strong> is more expensive, and families have diverse needs. Zakat respects this by
                                    providing <strong>food certificates</strong> so families can choose what they buy, ensuring dignity and cultural relevance.
                                </li>
                            </ul>
                        </Col>

                    </Row>
                </div>

                {/* How We Distribute Aid */}
                <div className="mb-4">
                    <h4>How We Distribute Aid:</h4>
                    <p style={{ fontSize: "16px" }}>
                        To ensure Zakat is given to those truly in need, GAMRC has a careful application and review process.
                        Individuals or families seeking assistance can apply by submitting a form along with required documents,
                        including valid ID for both husband and wife, a lease agreement, pay stubs, bank statements, etc.
                        Each local masjid has a dedicated GAMRC member. Once the documents are submitted, the ID will be forwarded to
                        the GAMRC representatives, who will conduct an interview to understand the applicant’s situation.
                        Requests for checks are then sent to different mosques. This process ensures funds are distributed with integrity,
                        compassion, and accountability.
                    </p>
                </div>

                {/* Buttons */}
                <div className="d-flex gap-2 mt-3 flex-wrap justify-content-center">
                    <Button
                        href="https://irusa.org/zakat-calculator/"
                        className="nav-button zakat-button"
                        target="_blank"
                        style={{ minWidth: "300px", whiteSpace: "nowrap", padding: "0.6rem 1.2rem" }}
                    >
                        <FaCalculator className="mb-1 mx-2" />
                        Calculate Your Zakat
                    </Button>
                    <Button
                        href="/PayZakatHere"
                        className="nav-button zakat-button"
                        target="_blank"
                        style={{ minWidth: "300px", whiteSpace: "nowrap", padding: "0.6rem 1.2rem" }}
                    >
                        <FaHandHoldingHeart className="mb-1 mx-2" />
                        Pay Zakat Here
                    </Button>
                </div>

                <hr style={{ height: "2px", backgroundColor: "black" }} />

                {/* Donate Text + Logos */}
                <p style={{ fontSize: "16px" }} className="text-center my-2">
                    Donate <a href="/PayZakatHere">here</a> or give your Zakat through Austin-area masajid
                </p>
                <MobileMasjidLogos />
                <p style={{ fontSize: "16px" }} className="text-center my-2">
                    JazakAllah Khair to our most generous communities at Nueces Mosque, ICBC and ICGA
                </p>

                <hr style={{ height: "2px", backgroundColor: "black" }} />

                {/* Where Does The Zakat Go */}
                <div className="text-center mb-3">
                    <Row className="align-items-center justify-content-center mb-2">
                        <Col xs="auto">
                            <h4 style={{ whiteSpace: "nowrap" }}>Where Does The Zakat Go?</h4>
                        </Col>
                        <Col xs="auto" className="d-flex justify-content-end">
                            <Button
                                href="/WhatWeDo"
                                style={{
                                    backgroundColor: "#42226D",
                                    borderColor: "#42226D",
                                    fontSize: "14px",
                                    fontWeight: "bold",
                                    fontFamily: "Lora",
                                    width: "auto",
                                }}
                            >
                                What We Do
                            </Button>
                        </Col>
                    </Row>
                    <p style={{ fontSize: "16px", color: "#000", maxWidth: "600px", margin: "0 auto" }}>
                        GAMRC supports vulnerable families in Austin by paying for rent, electricity, food, urgent debts, and medical expenses.
                        It provides support to domestic violence survivors, single moms, widows, and orphans. It distributes food baskets twice
                        during Ramadan and operates a space in a low-income complex where refugee kids attend Quran classes and educational programs.
                    </p>
                    <div className="d-flex justify-content-center mt-2" style={{ height: "250px", width: "100%" }}>
                        <ZakatChart />
                    </div>
                </div>
            </Container>

            <MobileFooter />
        </div>
    );
};

export default MobileAboutUs;
